import { PINNED_ASSET_SLUG } from "@/config/game";
import { useScrollLock } from "@/hooks/useScrollLock";
import { useTranslation } from "@repo/shared/i18n";
import React from "react";

import { BaseEvoPopup } from "./BaseEvoPopup";

interface RemoveEvosPopupPros {
  onClose: () => void;
  onConfirm: () => void;
  warningMessage?: React.ReactNode;
}

export const RemoveEvosPopup = ({
  onClose,
  onConfirm,
  warningMessage,
}: RemoveEvosPopupPros) => {
  const { t } = useTranslation(["evolutions", "common"]);
  useScrollLock(true);

  return (
    <BaseEvoPopup
      posLabel={t("popups.removeSaved.confirm")}
      onPositive={onConfirm}
      handleOnClose={onClose}
      title={t("popups.removeSaved.title")}
      imageUrl={
        import.meta.env.VITE_APP_ASSETS_BASE_URL +
        `/${PINNED_ASSET_SLUG}/evolutions-hub/my-evolutions/remove-evo.png`
      }
    >
      <>{warningMessage ?? <p>{t("popups.removeSaved.body")}</p>}</>
    </BaseEvoPopup>
  );
};
